export default __webpack_public_path__ + "static/media/DouglasHaynes.41dfcb59.png";